export default function footer() {
  const copyrightYearEl = document.querySelector<HTMLElement>(
    '[data-copyright-year]',
  );

  if (copyrightYearEl) {
    const currentYear = new Date().getFullYear();
    copyrightYearEl.textContent = currentYear.toString();
  }
}
